module.exports = __webpack_public_path__ + "img/create.adbed34a.svg";